
document.addEventListener("DOMContentLoaded", function () {
  
  const second = 1000,
        minute = second * 60,
        hour = minute * 60;

  function getNextVisitTime() {
    return new Date().getTime() + (15 * minute);
  }

  let nextVisitTime = getNextVisitTime();
  const x = setInterval(function() {
    const now = new Date().getTime();
    let distance = nextVisitTime - now;

    if (distance <= 0) {
      nextVisitTime = getNextVisitTime();
      distance = nextVisitTime - now;
    }

    const hours = String(Math.floor(distance / hour)).padStart(2, "0");
    const minutes = String(Math.floor((distance % hour) / minute)).padStart(2, "0");
    const seconds = String(Math.floor((distance % minute) / second)).padStart(2, "0");

    document.querySelectorAll(".hours").forEach(el => el.innerText = hours);
    document.querySelectorAll(".minutes").forEach(el => el.innerText = minutes);
    document.querySelectorAll(".seconds").forEach(el => el.innerText = seconds);
  }, 1000);
});



(function($) {
    function initAccordion() {
        $('.accordion-header').click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            const $header = $(this);
            const $content = $header.next('.accordion-content');
            $content.slideToggle();
            $('.accordion-content').not($content).slideUp();
            $('.accordion-header').not($header).removeClass('active');
            $header.toggleClass('active');
        });
    }
    $(document).ready(initAccordion);
})(jQuery);


// Promo Today End Date
function updatePromoDate() {
    const options = { month: 'short', day: 'numeric', timeZone: 'America/Los_Angeles' };
    const today = new Date().toLocaleDateString('en-US', options).toUpperCase();

    const promoDateElements = document.querySelectorAll('.promo-date-end');
    promoDateElements.forEach(element => {
        element.innerText = ' ' + today;
    });
}

updatePromoDate();

// Scroll Button Product Page
document.addEventListener("DOMContentLoaded", function () {
  const scrollButtons = document.querySelectorAll('.scroll-btn');

  scrollButtons.forEach(button => {
    button.addEventListener('click', function() {
      scrollToDiv('.product__details--product-page');
    });
  });

  function scrollToDiv(selector) {
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
});


